import Vue from 'vue';
import { StripePlugin } from '@vue-stripe/vue-stripe';

let els;

if ((els = document.querySelectorAll('.stripe-form')).length > 0) {

    let MIX_STRIPE_PUBLIC_KEY = process.env.MIX_STRIPE_PUBLIC_KEY;
    Vue.use(StripePlugin, {
        pk: MIX_STRIPE_PUBLIC_KEY,
        locale: 'fr'
    });

    for (let i = 0; i < els.length; i++) {
        const el = els[i];

        new Vue({
            el: el,
            name: 'StripeForm',
            data() {
                return {
                    cities: [],
                    disableBTN: false,
                    bookClasses: ' noActive ',
                    opened: false,
                    cardName: null,
                    token: null,
                    cardNumber: null,
                    cardExpiry: null,
                    cardCvc: null,
                };
            },
            computed: {
                stripeElements() {
                    return this.$stripe.elements();
                },
            },
            methods: {
                createToken(event, StripeToken) {
                    this.bookClasses = ' active ';
                    this.disableBTN = true;


                    if (StripeToken !== null)
                        return;

                    event.preventDefault();
                    const stripeIntent = window.passdata.stripe_intent;

                    this.$stripe.confirmCardPayment(stripeIntent.client_secret, {
                        payment_method: {
                            card: this.cardNumber
                        }
                    }).then((result) => {
                        if (result.error) {
                            console.log(result.error.message);
                        } else {
                            this.token = result.paymentIntent.id;
                            this.$nextTick(() => {
                                this.$refs.StripeForm.submit();
                            })
                        }
                    });
                }
            },
            mounted() {
                this.bookClasses = ' noActive ';
                this.disableBTN = false;
                const style = {
                    base: {
                        color: '#263232',
                        fontFamily: '"Poppins", sans-serif',
                        fontSmoothing: 'antialiased',
                        fontSize: '12px',
                        '::placeholder': {
                            color: '#263232',
                        },
                    },
                    invalid: {
                        color: '#fa755a',
                        iconColor: '#fa755a',
                    },
                };
                this.cardNumber = this.stripeElements.create('cardNumber', { style, placeholder: 'Numéro de la carte *' });
                this.cardNumber.mount('#card-number');
                this.cardExpiry = this.stripeElements.create('cardExpiry', { style, placeholder: "Date d'expiration *" });
                this.cardExpiry.mount('#card-expiry');
                this.cardCvc = this.stripeElements.create('cardCvc', { style, placeholder: "CVC *" });
                this.cardCvc.mount('#card-cvc');
            },
            beforeDestroy() {
                this.cardNumber.destroy();
                this.cardExpiry.destroy();
                this.cardCvc.destroy();
            }
        });
    }
}
